import { setConfiguration } from '@configuratorware/configurator-frontendgui/App/configuration';
import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import ConfiguratorScreen from './App/Screens/ConfiguratorScreen';
import designViewReducer from './App/Reducers/DesignView/Reducer';
import designAreaReducer from './App/Reducers/DesignArea/Reducer';
import ConfiguratorService from './App/Services/ConfiguratorService';

const prod = process.env.NODE_ENV === 'production';

const envDomains = {
  test: '',
  int: 'http://int.bbtrading.local',
  local: 'http://int.bbtrading.local',
  prod: '',
};

const domain = envDomains[prod ? 'prod' : 'int'];

const query = new URLSearchParams(location.search);

const adminMode = query.get('_adminmode');

const customApplicationConfiguration = {
  network: {
    // timeout: 40000,
    host: domain,
    baseURL: `${domain}/frontendapi/`,
    adminBaseURL: `${domain}/api/`,
    imageURL: `${domain}`,
    resourcesURL: `${domain}`,
  },
  screens: {
    Configurator: ConfiguratorScreen,
  },
  reducers: {
    designView: designViewReducer,
    designArea: designAreaReducer,
  },
  services: {
    ConfiguratorService,
  },
  locales: [{ code: 'de_CH', preferred: true }, { code: 'en_US' }, { code: 'fr_CH' }],
  disableBeforeunloadWarning: true,
};

setConfiguration(customApplicationConfiguration);

if (adminMode) {
  // in admin mode all requests should contain the no-cache header to get the most fresh content
  Api.setCacheControlHeader('no-cache');
}

export default customApplicationConfiguration;
